import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import FieldAutocomplete from 'components/Field/Autocomplete';
import FieldSelect from 'components/Field/Select';
import Translate from 'components/Translate';
import { ICity, IProvince } from 'interfaces/ICity';
import React from 'react';
import { getCitiesByState, getProvinces } from 'services/LocationService';
import { paymentService } from 'services/PaymentService';

export interface ICityState {
  province: string;
  city: string;
  cityId?: string;
  country?: string;
}

interface IState extends IStateBase {
  model: ICityState;
  citiesFrom?: string;
  cities: ICity[];
  provinces: IProvince[];
}

interface IProps {
  value: ICityState;
  templateId?: number;
  onChange: (result: ICityState) => void;
  disableAutocompleteOnProvince?: boolean;
}

export default class CityState extends BaseComponent<IState, IProps> {
  constructor(props: any) {
    super(props);
    this.state = { cities: [], provinces: [], model: props.value };
  }

  componentDidMount() {
    this.bindModel(paymentService.getAddress());

    const province = this.state.model.province;

    if (province && province != 'none') {
      this.loadCities(province);
    }

    getProvinces()
      .bindComponent(this)
      .subscribe(provinces => this.setState({ provinces }));
  }

  componentWillUpdate(nextProps: IProps, nextState: IState) {
    const nextProvince = nextState.model.province;

    if (this.state.citiesFrom !== nextProvince) {
      this.loadCities(nextProvince);
    }
  }

  loadCities(province: string) {
    this.setState({ citiesFrom: province, cities: [] });

    getCitiesByState(province)
      .filter(province => province.length > 0)
      .retry(5)
      .loader()
      .bindComponent(this)
      .subscribe(cities => this.setState({ citiesFrom: province, cities }));
  }

  selectProvince = (province: string) => {
    this.setModel({ province, city: 'none' });
    this.loadCities(province);
  };

  selectCity = (city: string) => {
    this.setModel({ ...this.state.model, city });
    setTimeout(() => {
      this.props.onChange({ ...this.state.model });
    });
  };

  setProvince = (value: string) => {
    this.selectProvince(value);
  };

  render() {
    if (!this.state.model) {
      return <div />;
    }

    const { model, cities, provinces } = this.state;
    const { templateId: template } = this.props;

    model.province = model.province || 'none';
    model.city = model.city || 'none';

    return (
      <Grid container spacing={template === 18 ? 2 : 1}>
        <Grid item sm={model.province !== 'none' ? 3 : 12} xs={12}>
          {this.props.disableAutocompleteOnProvince ? (
            <FieldSelect
              id="find-cep-select-state"
              className="state-container field normal"
              label={<Translate term={'Estado'} />}
              value={model.province}
              validation="requiredSelect"
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-province'
              }}
              inputProps={{
                className: 'theme-input-select chk-cityState__state br',
                id: 'find-cep-select-state'
              }}
              onChange={this.setProvince}
            >
              {provinces.map(p => (
                <MenuItem key={p.uf} value={p.uf}>
                  {p.uf}
                </MenuItem>
              ))}
            </FieldSelect>
          ) : (
            <FieldAutocomplete
              hideUnselectIcon
              hideSearchIcon
              id="find-cep-select-state"
              label={<Translate term={'Estado'} />}
              value={model.province}
              validation="requiredSelect"
              className="chk-cityState__state"
              inputProps={{
                className: 'theme-input',
                id: 'province-autocomplete'
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-province'
              }}
              onChange={this.selectProvince}
              options={provinces.map(p => ({ label: p.uf, value: p.uf }))}
            />
          )}
        </Grid>

        {model.province !== 'none' && (
          <Grid item sm={9} xs={12}>
            <FieldAutocomplete
              hideUnselectIcon
              hideSearchIcon
              id="find-cep-select-city"
              label={<Translate term="Cidade" />}
              value={model.city}
              validation="requiredSelect"
              className="chk-cityState__container field normal"
              inputProps={{
                className: 'theme-input',
                id: 'find-cep-select-city'
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-city'
              }}
              onChange={this.selectCity}
              options={cities.map(c => ({ label: c.name, value: c.name }))}
            />
          </Grid>
        )}
      </Grid>
    );
  }
}
